import { css } from '@/styled-system/css';

export const fdpFloorplansStyles = css({
  width: '100%',
  paddingTop: '1x',
  marginBottom: '64px',
  md: {
    marginBottom: 'auto',
  },
});

export const headerContStyles = css({
  paddingTop: '2x',
  paddingBottom: '2x',
  paddingLeft: '2x',
  paddingRight: '2x',
  borderBottomWidth: '1px',
  borderBottomStyle: 'solid',
  borderBottomColor: '{colors.hpxGrey100}',
  md: {
    paddingTop: '2x',
    paddingBottom: '2x',
    paddingLeft: '0',
    paddingRight: '0',
    borderWidth: '0',
    borderStyle: 'none',
  },
});

export const headerStyles = css({
  paddingTop: '2x',
  paddingBottom: '2x',
  paddingLeft: '0',
  paddingRight: '0',
});

export const summaryStyles = css({
  paddingTop: '1x',
  paddingBottom: '1x',
  paddingLeft: '0',
  paddingRight: '0',
});

export const summaryTopStyles = css({
  fontSize: 'lg',
  fontWeight: 'bold',
});

export const summaryBottomStyles = css({
  display: 'flex',
  flexDirection: 'column',
  gap: '4px',
});

export const summaryPriceStyles = css({
  display: 'flex',
  alignItems: 'center',
  gap: '8px',
  fontSize: '16px',
  color: '{colors.hpxGrey600}',
});

export const summarySqftStyles = css({
  fontSize: '16px',
  color: '{colors.hpxGrey600}',
});

export const imgDetailsContStyles = css({
  display: 'flex',
  flexDirection: 'column',
  md: {
    flexDirection: 'row',
  },
});

export const imgContStyles = css({
  display: 'flex',
  justifyContent: 'center',
  alignContent: 'center',
  paddingTop: '4x',
  paddingBottom: '4x',
  md: {
    flex: '1',
    paddingTop: '0',
    paddingBottom: '0',
    paddingLeft: '0',
    paddingRight: '0',
    borderWidth: '1px',
    borderStyle: 'solid',
    borderColor: '{colors.hpxGrey100}',
    height: 'min-content',
  },
});

export const detailsContStyles = css({
  paddingTop: '0',
  paddingBottom: '0',
  paddingLeft: '16px',
  paddingRight: '16px',
  md: {
    paddingTop: '0',
    paddingBottom: '0',
    paddingLeft: '6x',
    paddingRight: '16px',
    width: '400px',
  },
});

export const tableContainerStyles = css({
  // No additional padding needed - handled by parent detailsContStyles
});

export const noticeWrapperStyles = css({
  marginBottom: '16px',
});

export const labelHeaderStyles = css({
  display: 'grid',
  gridTemplateColumns: '80px 1fr 1fr 0.7fr',
  alignItems: 'center',
  height: '48px',
  paddingTop: '0',
  paddingBottom: '0',
  paddingLeft: '16px',
  paddingRight: '16px',
  color: '{colors.hpxGrey600}',
  borderWidth: '1px',
  borderStyle: 'solid',
  borderColor: '{colors.hpxGrey100}',
  borderBottomWidth: '0',
  fontSize: 'sm',
  fontWeight: 'bold',
});

export const labelHeaderStyles3Col = css({
  display: 'grid',
  gridTemplateColumns: '1fr 1fr 0.7fr',
  alignItems: 'center',
  height: '48px',
  paddingTop: '0',
  paddingBottom: '0',
  paddingLeft: '16px',
  paddingRight: '16px',
  color: '{colors.hpxGrey600}',
  borderWidth: '1px',
  borderStyle: 'solid',
  borderColor: '{colors.hpxGrey100}',
  borderBottomWidth: '0',
  fontSize: 'sm',
  fontWeight: 'bold',
});

export const unitStyles = css({
  display: 'grid',
  gridTemplateColumns: '80px 1fr 1fr 0.7fr',
  alignItems: 'center',
  height: '48px',
  paddingTop: '0',
  paddingBottom: '0',
  paddingLeft: '16px',
  paddingRight: '16px',
  color: '{colors.hpxGrey600}',
  borderWidth: '1px',
  borderStyle: 'solid',
  borderColor: '{colors.hpxGrey100}',
  borderBottomWidth: '0',
  fontSize: 'md',
  _last: {
    borderBottomWidth: '1px',
    borderBottomStyle: 'solid',
    borderBottomColor: '{colors.hpxGrey100}',
  },
});

export const unitStyles3Col = css({
  display: 'grid',
  gridTemplateColumns: '1fr 1fr 0.7fr',
  alignItems: 'center',
  height: '48px',
  paddingTop: '0',
  paddingBottom: '0',
  paddingLeft: '16px',
  paddingRight: '16px',
  color: '{colors.hpxGrey600}',
  borderWidth: '1px',
  borderStyle: 'solid',
  borderColor: '{colors.hpxGrey100}',
  borderBottomWidth: '0',
  fontSize: 'md',
  _last: {
    borderBottomWidth: '1px',
    borderBottomStyle: 'solid',
    borderBottomColor: '{colors.hpxGrey100}',
  },
});

export const badgeColumnStyles = css({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
});

export const unitEmptyStyles = css({
  borderWidth: '1px',
  borderStyle: 'solid',
  borderColor: '{colors.hpxGrey100}',
});

export const labelPriceStyles = css({
  // Width handled by grid layout
});

export const unitPriceStyles = css({
  color: '{colors.hpxBlue600}',
});

export const labelAvailabilityStyles = css({
  // Width handled by grid layout
});

export const unitAvailabilityStyles = css({
  // Width handled by grid layout
});

export const labelNameStyles = css({
  // Width handled by grid layout
});

export const unitNameStyles = css({
  // Width handled by grid layout
});

export const unitPriceEmptyStyles = css({
  fontSize: 'sm',
  fontWeight: 'bold',
  color: '{colors.hpxGrey500}',
});

export const unitAvailabilityEmptyStyles = css({
  fontSize: 'sm',
  fontWeight: 'bold',
  color: '{colors.hpxGrey500}',
});

export const unitNameEmptyStyles = css({
  fontSize: 'sm',
  fontWeight: 'bold',
  color: '{colors.hpxGrey500}',
});
